import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { ContentLoader, ContentNoData } from 'src/Components';
import { BulkFileActions } from 'src/Redux';
import { UnsignedPaymentFiles } from './UnsignedPaymentFiles';
import { UnsignedPaymentFilesTemporary } from './UnsignedPaymentFilesTemporary';

export const UnsignedPaymentFilesWrapper = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { FilesList, loading } = useSelector((state: any) => state.BulkFileReducer);

  useEffect(() => {
    if (!location?.state?.paymentSuccess) {
      dispatch(BulkFileActions.getBulkPaymentsFileList() as any);
    }
  }, []);

  if (loading) {
    return <ContentLoader />;
  }

  if (!FilesList?.length) {
    return <ContentNoData id="UnsignedPaymentFilesWrapper" />;
  }

  return (
    <>
      <UnsignedPaymentFiles FilesList={FilesList.filter((file: any) => file.VopEnabled)} />
      <UnsignedPaymentFilesTemporary FilesList={FilesList.filter((file: any) => !file.VopEnabled)} />
    </>
  );
};
